import jwt from "../middlewares/jwt.js";
import moment from "moment";

const api = new jwt.API();

const Unicorn = {
  namespaced: true,
  state: () => ({
    totalStock: 0,
    newStockToday: 0,
    dataTable: {},
  }),
  mutations: {
    totalStock(state, newValue) {
      state.totalStock = newValue;
    },
    newStockToday(state, newValue) {
      state.newStockToday = newValue;
    },
    dataTable(state, newValue) {
      state.dataTable = newValue;
    },
  },
  actions: {
    addcount(context) {
      console.log(context);
    },
    getData({ dispatch, commit, getters, rootGetters }) {
    //   console.log(dispatch, commit, getters, rootGetters);
      api
        .get("indoor/getstock")
        .then((result) => {
          console.log("result", result);
          console.log("result", result.data, typeof result.data);

          // variable count data
          let sumStocked = 0;
          let sumToday = 0;
          let inStock = [];

          for (let index = 0; index < result.data.length; index++) {
            const element = result.data[index];
            // console.log(element);

            // count stocked
            // change format time
            if (element.isStock == true) {
              sumStocked += 1;

              // change format time
              // - 25200000
              const d = moment(
                new Date(element.checkin_timestamp).getTime()
              ).format("DD/MM/YYYY LTS");
              element["showTime"] = d;
              inStock.push(element);
            }

            // count stock today
            if (
              moment()
                .format()
                .split("T")[0] === element.checkin_timestamp.split("T")[0]
            ) {
              sumToday++;
            }
          }

          console.log("result", sumStocked, sumToday, inStock);

          // add data to state
          commit('totalStock',sumStocked)
          commit('newStockToday',sumToday)
          commit('dataTable',inStock)
        //   console.log("result", getters.totalStock, getters.newStockToday, getters.dataTable);

          
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
  },
  getters: {
    count(state) {
      return state.countA;
    },
    totalStock(state) {
      return state.totalStock;
    },
    newStockToday(state) {
      return state.newStockToday;
    },
    dataTable(state) {
      return state.dataTable;
    },
  },
};

export default Unicorn;
